import { Action } from "../../index";
import { Dispatch } from "react-redux";
import { combineReducers } from "redux";

/**
 * Actions
 */



// Select chat
export const SELECT_CHAT = "meumedico/ui/SELECT_CHAT";
export function selectChat(id: string) {
    return {
        type: SELECT_CHAT,
        payload: {
            id
        }
    }
}

// Select sidebar view (list of chats, editing user, creating group)
export const SELECT_SIDEBAR_VIEW = "meumedico/ui/SELECT_SIDEBAR_VIEW";
export function selectSidebarView(view: string) {
    return {
        type: SELECT_SIDEBAR_VIEW,
        payload: {
            view
        }
    }
}

// Select sidebar view (list of chats, editing user, creating group)
export const SET_DIALOG_STATUS = "meumedico/ui/SET_DIALOG_STATUS";
export function setDialogStatus(dialog: string, status: boolean) {
    return {
        type: SET_DIALOG_STATUS,
        payload: {
            dialog,
            status
        }
    }
}

/**
 * Reducers
 */

// Chats Reducer 

interface IUiChatState {
     selected: string;
};

const INITIAL_CHAT_STATE = {    
    selected: ""
};

interface selectChatPayload {
    id: string;
};

function chatsReducer(state: IUiChatState = INITIAL_CHAT_STATE, action: Action<selectChatPayload>) {
    switch(action.type) {
        case SELECT_CHAT:
            return Object.assign({}, state, {
                selected: action.payload.id
            });
        default:
            return state;
    }
}

// Sidebar Reducer

interface IUiSidebarState {
     view: string;
};

const INITIAL_SIDEBAR_STATE = {    
    view: "chatList",
    menuOpen: false
};

interface selectSidebarViewPayload {
    view: string;
};

interface setMenuSidebarPayload {
    menuStatus: boolean;
}


function sidebarReducer(state: IUiSidebarState = INITIAL_SIDEBAR_STATE, action: Action<selectSidebarViewPayload & setMenuSidebarPayload>) {
    switch(action.type) {
        case SELECT_SIDEBAR_VIEW:
            return Object.assign({}, state, {
                view: action.payload.view
            });
        default:
            return state;
    }
}

// Login Reducer

// Dialog reducers

interface IUiDialogState {
     createGroup: boolean;
     invitePatient: boolean;
     inviteDoctor: boolean;
     inviteToGroup: boolean;
     createGroupWithPatient: boolean;
     termsOfUseDialog: boolean;
     doctorsDialog: boolean;
     [dialog: string]: boolean;
};

const INITIAL_DIALOG_STATE = {
    createGroup: false,
    inviteDoctor: false,
    invitePatient: false,
    inviteToGroup: false,
    createGroupWithPatient: false,
    termsOfUseDialog: false,
    doctorsDialog: false
};

interface SetDialogStatusPayload {
    dialog: string;
    status: boolean;
};

function dialogReducer(state: IUiDialogState = INITIAL_DIALOG_STATE, action: Action<SetDialogStatusPayload>) {
    switch(action.type) {
        case SET_DIALOG_STATUS:
            return (() => {
                let dialogs = Object.assign({}, state);
                dialogs[action.payload.dialog] = action.payload.status;
                return dialogs;
            })();
        default:
            return state;
    }
}


// Combine Reducers

export interface IUiState {
    chats: IUiChatState,
    sidebar: IUiSidebarState,
    dialogs: IUiDialogState
};

const INITIAL_STATE: IUiState = {
    chats: INITIAL_CHAT_STATE,
    sidebar: INITIAL_SIDEBAR_STATE,
    dialogs: INITIAL_DIALOG_STATE
};

const reducers = combineReducers({
    chats: chatsReducer,
    sidebar: sidebarReducer,
    dialogs: dialogReducer
});

export default reducers;


// WEBPACK FOOTER //
// ./src/redux/modules/ui/ui.tsx